// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_avatars.styl
// module id = 69
// module chunks = 0